<script>
	import { getContext } from 'svelte';
	import HeaderMenuItem from './HeaderMenuItem.svelte';

	import { profile, signout } from './images/icons.svelte';

	let { active } = $props();

	let userData = getContext('userData');
</script>

<HeaderMenuItem transparent position="left">
	{#snippet title()}
		<span
			class={[
				'xs:fill-white xs:text-white',

				{
					'md:fill-inherit md:text-inherit': !active,
				},
				{
					'md:fill-indow-blue md:text-indow-blue': active,
				},
			]}
		>
			<span class="flex flex-col gap-1 text-sm">
				<span class="w-7 place-self-center">
					{@render profile()}
				</span>
				<span
					class="
       hidden
       md:inline
     ">DASHBOARD</span
				>
			</span>
		</span>
	{/snippet}

	<ul class="list-none pt-3 text-left font-medium whitespace-nowrap">
		<li class="m-0">
			<a
				href="/my/dashboard"
				class="
      block px-6 py-3 text-inherit no-underline
      hover:bg-gray-100
    ">My Dashboard</a
			>
		</li>
		<li class="m-0">
			<a
				href="/my/profile"
				class="
      block px-6 py-3 text-inherit no-underline
      hover:bg-gray-100
    ">My Profile</a
			>
		</li>
		<li
			class="m-0 border-t border-indow-blue px-6 pt-3 text-sm text-indow-grey"
		>
			{userData.signedIn}
		</li>
		<li class="m-0">
			<a
				data-sveltekit-preload-data="off"
				href="/signout"
				onclick={() => {
					delete userData.signedIn;
				}}
				class="
      flex flex-row place-items-center gap-2 px-6 py-3 text-gray-400
      no-underline
      hover:text-indow-blue
    "
			>
				<span class="inline-block w-5">
					{@render signout()}
				</span>Sign Out</a
			>
		</li>
	</ul>
</HeaderMenuItem>
